export default {
    title: "Objednávka jménem",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Vyplňte prosím uživatelské jméno nebo e-mail",
            notFound: "Uživatelé nenalezeny",
            errors: {
                myself: "E-mail se musí lišit od vašeho"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Předložit",
            processing: "Odesílání"
        }
    },
    error: {
        userNotExists: "{email} neexistuje",
        country: {
            default: "OI momentálně není v zemi uživatele k dispozici",
            ALPHA3: ""
        }
    }
}